// Calculate dosage based on survey answers
export function calculateDosage(answers) {
  let weightScore = 0;
  let severityScore = 0;

  // Weight score
  switch(answers.demographics?.weight) {
    case '<50': weightScore = 0; break;
    case '50-70': weightScore = 1; break;
    case '70-90': weightScore = 2; break;
    case '>90': weightScore = 3; break;
    default: weightScore = 1;
  }

  // Duration score
  switch(answers.duration) {
    case '<1month': severityScore += 0; break;
    case '1-3months': severityScore += 1; break;
    case '>3months': severityScore += 2; break;
    default: severityScore += 0;
  }

  // Frequency score
  switch(answers.frequency) {
    case '1-2': severityScore += 0; break;
    case '3-4': severityScore += 1; break;
    case '5+': severityScore += 2; break;
    default: severityScore += 0;
  }

  // Daytime impact score
  if (answers.daytimeImpact) {
    const impactCount = answers.daytimeImpact.filter(i => i !== 'none').length;
    if (impactCount === 0) severityScore += 0;
    else if (impactCount <= 2) severityScore += 1;
    else severityScore += 2;
  }

  // Special cases for increased dosage
  const hasAnxiousSymptoms = 
    answers.fallingFeeling === 'anxious' || 
    answers.wakeFeeling === 'anxious' ||
    (answers.constitution1 && answers.constitution1.length > 1);
  
  const hasSevereSleepIssue = 
    answers.timeToSleep === '>2hr' || 
    answers.wakeTimes === 'many';

  if (hasAnxiousSymptoms || hasSevereSleepIssue) {
    severityScore += 1;
  }

  // Calculate final dosage: 9 + W + S*0.67
  const totalScore = weightScore + (severityScore * 0.67);
  
  // Round to 3 tiers: 3g, 4g, 5g
  if (totalScore <= 2) {
    return { amount: 3, level: 'light' };
  } else if (totalScore <= 4) {
    return { amount: 4, level: 'medium' };
  } else {
    return { amount: 5, level: 'heavy' };
  }
}

// Determine review status
export function getReviewStatus(answers, dosage) {
  // Red flags - must review
  if (answers.safety && !answers.safety.includes('none')) {
    return { 
      status: 'red', 
      label: 'Professional Review Required', 
      message: 'Health risk factors detected, professional review required.' 
    };
  }
  
  if (answers.demographics?.age === 'other') {
    return { 
      status: 'red', 
      label: 'Professional Review Required', 
      message: 'Age factor requires professional confirmation.' 
    };
  }

  // Yellow flags - priority review
  if (answers.duration === '>3months' && answers.frequency === '5+') {
    return { 
      status: 'yellow', 
      label: 'Priority Review', 
      message: 'Chronic severe insomnia, priority review recommended.' 
    };
  }
  
  if (dosage.amount === 5) {
    return { 
      status: 'yellow', 
      label: 'Priority Review', 
      message: 'High dosage formula, professional confirmation required.' 
    };
  }

  // Green - auto approve
  return { 
    status: 'green', 
    label: 'Auto Approved', 
    message: 'Formula generated, proceeding to production.' 
  };
}

// Base formula for sleep
export const SLEEP_BASE_FORMULA = [
  { name: 'Poria Mushroom', amount: '3g' },
  { name: 'Longan Fruit', amount: '2g' },
  { name: 'Reishi Mushroom', amount: '1g' },
  { name: 'Prepared polygonatum root', amount: '2g' },
  { name: 'Ophiopogon Root', amount: '2g' },
  { name: 'Jujube Slices', amount: '1 pc (approx. 2g)' }
];
